<div class="pv-8 topbar">
  <div class="container">
    <div class="row noGutter f aic jcfe">
      <div class="col-xs-9 col-md-3">
        <img src="./assets/images/labrador/labrador-logo.svg" alt="labrador logo"
          aria-label="labrador logo" class="logo" />
      </div>
      <div class="col-xs-3 col-md-9">
        <div class="hideMD showLG jcfe aic" *ngIf="!isHideDrawer">
          <app-top-menu></app-top-menu>
        </div>
        <div class="pos-rel hideLG showMD">
          <img class="menu-icon" alt="gtm-menuicon menu icon" src="./assets/images/Menu.svg" (click)="toggleMenu()">
        </div>
      </div>
    </div>
  </div>
</div>